"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConnectorClient = exports.applyApi = exports.connectClient = exports.isPluginMessage = exports.isHandshake = void 0;
const tslib_1 = require("tslib");
const plugin_utils_1 = require("@remixproject/plugin-utils");
const client_1 = require("./client");
const api_1 = require("./api");
/** Check if a message is an handshake */
function isHandshake(message) {
    return message.key === 'handshake' && (message.action === 'request' || message.action === 'call');
}
exports.isHandshake = isHandshake;
/** Check if an event.data is a plugin message is an handshake */
function isPluginMessage(message) {
    return (typeof message === 'object') && ('action' in message) && ('name' in message);
}
exports.isPluginMessage = isPluginMessage;
/**
 * Connect a plugin to the engine for a specific connector
 * @param connector The connector for this plugin
 * @param client The client instance of the plugin
 * @example With a client
 * ```typescript
 * const client = new PluginClient()
 * connectClient(new IframeConnector(client), client);
 * ```
 */
function connectClient(connector, client = new client_1.PluginClient()) {
    let isLoaded = false;
    connector.on(({ action, key, name, payload, id, requestInfo, error }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            // If handshake set isLoaded
            if (isHandshake({ action, key })) {
                if (!isLoaded) {
                    isLoaded = true;
                    client.events.on('send', (msg) => connector.send(msg));
                    client.events.emit('loaded');
                    client.name = payload[0];
                }
                // Send back the list of methods exposed by the plugin
                const message = { action: 'response', name, key, id, payload: client.methods };
                connector.send(message);
                return;
            }
            // Check if is isLoaded
            if (!isLoaded)
                throw new Error('Handshake before communicating');
            switch (action) {
                case 'emit':
                case 'notification': {
                    client.events.emit(plugin_utils_1.listenEvent(name, key), ...payload);
                    break;
                }
                case 'response': {
                    client.events.emit(plugin_utils_1.callEvent(name, key, id), payload, error);
                    delete client.currentRequest;
                    break;
                }
                case 'call':
                case 'request': {
                    const path = requestInfo && requestInfo.path;
                    const method = plugin_utils_1.getMethodPath(key, path);
                    if (!client[method]) {
                        throw new Error(`Method ${method} doesn't exist on plugin ${name}`);
                    }
                    client.currentRequest = requestInfo;
                    const result = yield client[method](...payload);
                    const message = { action: 'response', name, key, id, payload: result };
                    connector.send(message);
                    break;
                }
            }
        }
        catch (err) {
            console.error(err);
            const message = { action: action === 'request' ? 'response' : action, name, key, id, error: err.message || err };
            connector.send(message);
        }
    }));
    // Request handshake if not loaded
    if (!isLoaded) {
        connector.send({ action: 'request', key: 'handshake', id: -1 });
    }
    return client;
}
exports.connectClient = connectClient;
/**
 * Add shortcut to the api requested by the client on it.
 * @description
 * Once applied, the client can do `client.solidity.compile(x)` instead of `client.call('solidity', 'compile', x)`
 * @param client The client on which we apply the api
 */
function applyApi(client) {
    const profiles = client.options.customApi || {};
    for (const name in profiles) {
        if (client[name]) {
            const error = `Your plugin client should have a method/attribut named "${name}" as it is the name of another plugin. `;
            const solution = `To prevent this set the option "customApi" to "null" in the client's options. `;
            const example = `For exemple: "const client = createClient(new PluginClient<any, any>({ customApi: null }))".`;
            throw new Error(error + solution + example);
        }
        client[name] = api_1.createApi(client, profiles[name]);
    }
}
exports.applyApi = applyApi;
/**
 * Create & connect a client with a connector.
 * @param connector A communication layer connector
 * @param client The plugin client
 */
exports.createConnectorClient = (connector, client = new client_1.PluginClient()) => {
    const c = client;
    connectClient(connector, c);
    applyApi(c);
    return c;
};
//# sourceMappingURL=connector.js.map